import clsx from 'clsx';

import AnswerStatusChip from '@features/homework-management/components/answer-status-chip/AnswerStatusChip';
import { StudentHomeworkViewType } from '@features/homework-management/constants';
import { ReviewCardProps } from '@types';
import { AnswerStatus } from '@constants/answer';

import Button from '../button/Button';

const formatQuestionType = (type?: string) => {
  if (!type) return '';

  const normalizedType = type.toLowerCase();

  const labels: Record<string, string> = {
    mcq: 'MCQ',
    msq: 'MSQ',
    la: 'Long Answer',
    sa: 'Short Answer'
  };

  return (
    labels[normalizedType] ||
    type.replace(/[_-]/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
  );
};

const ReviewCard = (props: ReviewCardProps) => {
  const {
    className = '',
    handleResultView,
    question,
    questionNo,
    strictModalType
  } = props;

  const handleViewQuestionDetails = (type: StudentHomeworkViewType) => {
    if (handleResultView) handleResultView(type, question?.questionId);
  };

  const questionType = formatQuestionType(question?.type);

  return (
    <div
      className={clsx(
        'flex items-center gap-6 rounded-2xl border border-primary1 bg-white px-6 py-3 text-sm font-normal mobile:flex-col',
        className
      )}
    >
      <div className="flex grow items-center gap-6 mobile:w-full mobile:flex-wrap mobile:justify-between mobile:gap-2 tablet:justify-stretch tablet:gap-2">
        <div className="flex grow items-center gap-6 mobile:w-full mobile:flex-wrap mobile:justify-between mobile:gap-2">
          <div className="order-1 font-semibold tablet:w-3/5 desktop:w-56">
            Question {(questionNo || 0) + 1}
          </div>

          <div className="order-2 w-28 shrink-0">
            <span
              className="
        inline-flex max-w-full items-center rounded-full
        bg-primaryLite px-2.5 py-1 text-xs font-medium
        text-primary6 sm:px-3
      "
            >
              <span className="truncate">{questionType}</span>
            </span>
          </div>

          <AnswerStatusChip
            status={question.result || AnswerStatus.NOT_STARTED}
            className="order-3 min-w-20 grow mobile:order-4 mobile:w-20 mobile:grow-0 mobile:text-wrap"
          />

          <div className="order-4 flex w-28 shrink-0 items-center mobile:order-3 mobile:w-auto mobile:grow-0">
            <div className="me-1">Points:</div>
            <div className="font-semibold">
              {question?.point}/{question?.maximumPoint}
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-2 align-middle mobile:w-full">
        {(!strictModalType ||
          strictModalType === StudentHomeworkViewType.RESULT_VIEW) && (
          <Button
            variant="secondary"
            className="min-w-fit bg-theme mobile:w-1/2"
            label="Result"
            handleClick={() =>
              handleViewQuestionDetails(StudentHomeworkViewType.RESULT_VIEW)
            }
            disabled={!question.result}
          />
        )}

        {(!strictModalType ||
          strictModalType === StudentHomeworkViewType.STUDENT_VIEW) && (
          <Button
            variant="secondary"
            className="min-w-fit bg-theme mobile:w-1/2"
            label="Student View"
            handleClick={() =>
              handleViewQuestionDetails(StudentHomeworkViewType.STUDENT_VIEW)
            }
            disabled={!question.result}
          />
        )}
      </div>
    </div>
  );
};

export default ReviewCard;
